import { render } from "./TextView2.vue?vue&type=template&id=136faa0a"
import script from "./TextView2.vue?vue&type=script&lang=js"
export * from "./TextView2.vue?vue&type=script&lang=js"

import "./TextView2.vue?vue&type=style&index=0&id=136faa0a&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__